module.exports = __webpack_public_path__ + "img/logo.a6f5ed7e.png";